<template>
  <div v-if="isLoading">
    <LoaderIcon></LoaderIcon>
  </div>
  <div
    v-else
    class="min-h-full h-screen"
    :style="
      clientStore.getCustomBackgroundImagePath !== null
        ? 'background-image: url(' +
          clientStore.getCustomBackgroundImagePath +
          '); '
        : ''
    "
    :class="{
      'custom-background-image':
        clientStore.getCustomBackgroundImagePath !== null,
    }"
  >
    <BackgroundBubbles
      v-if="clientStore.getCustomBackgroundImagePath === null"
    />
    <div
      class="flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8 z-20"
    >
      <ResendActivationMailModal
        :open="resendActivationMailModalOpen"
        @close="closeResendActivationMailModal"
      />
    </div>
    <FooterLinks position-fixed bg-fixed />
  </div>
</template>

<script>
import { useUserStore } from "../../../store/v2/user";
import { useClientStore } from "../../../store/v2/client";
import bubble from "../../../animations/bubbles/assessment-bubbles.json";
import LoaderIcon from "../../../components/v2/loader/LoaderIcon";
import FooterLinks from "../../../components/v2/sbk/FooterLinks.vue";
import BackgroundBubbles from "../../../components/v2/layout/BackgroundBubbles";
import { SBK_BLUE } from "../../../enum/v2/sbk";
import ResendActivationMailModal from "../../../components/v2/sbk/ResendActivationMailModal.vue";

export default {
  name: "LoginPage",
  components: {
    FooterLinks,
    ResendActivationMailModal,
    BackgroundBubbles,
    LoaderIcon,
  },
  props: {
    msg: String,
  },
  setup() {
    const userStore = useUserStore();
    const clientStore = useClientStore();
    const redirectToAuthentication = inject("redirectToAuthentication");

    return {
      userStore,
      clientStore,
      redirectToAuthentication,
    };
  },
  data() {
    return {
      error: null,
      client: null,
      bubble,
      resendActivationMailModalOpen: false,
      isLoading: true,
    };
  },
  async mounted() {
    if (this.$userAuthenticator.isAuthorized()) {
      await this.userStore.getUser();
      await this.redirectToForMe();
    }

    if (
      this.$route.params.atmCampaign !== null &&
      this.$route.params.atmCampaign !== undefined
    ) {
      this.client = await this.clientStore
        .getClient(null, this.$route.params.atmCampaign)
        .catch((err) => {
          this.$userAuthenticator.logout();
          this.$router.push({
            name: "login",
          });
        });
    }

    this.clientStore.setAtmCampaign(this.$route.params.atmCampaign ?? null);
    this.clientStore.setPasswordResetRedirectTarget("login");
    this.clientStore.setClientColorsManually(
      SBK_BLUE,
      SBK_BLUE,
      SBK_BLUE,
      SBK_BLUE,
      SBK_BLUE
    );
    this.isLoading = false;

    if (
      this.client &&
      this.client.isMaintenance &&
      this.userStore.getCanBypassMaintenance !== true
    ) {
      this.redirectToMaintenance();
    }

    if (this.$userAuthenticator.isAuthorized()) {
      this.redirectToForMe();
    }

    // this page is available under /sbk/login, /sbk/resend-activation
    // route /sbk/login will always redirect to backend's login page but remain available to not break external links
    // route /sbk/resend-activation is called from the backend's authentication flow simply to show the modal for it
    if (this.$route.name === "sbkResendActivation") {
      this.resendActivationMailModalOpen = true;
    } else {
      this.redirectToAuthentication({
        atmCampaign: this.$route.params.atmCampaign,
        isSbk: 1,
      });
    }
  },
  methods: {
    redirectToForMe() {
      this.$router.push({
        name: "feed",
        params: {
          slug: this.clientStore.slug,
        },
      });
    },
    redirectToMaintenance() {
      this.$router.push({
        name: "maintenancePage",
      });
    },
    closeResendActivationMailModal() {
      this.resendActivationMailModalOpen = false;
      this.redirectToAuthentication({
        atmCampaign: this.$route.params.atmCampaign,
        isSbk: 1,
      });
    },
  },
};
</script>
<style scoped>
.st0 {
  display: none;
}
.st1 {
  fill: #003c6e;
}
</style>
